const { ccclass, property, menu } = cc._decorator;

@ccclass('CustomAnimData')
class CustomAnimData{
    @property(cc.String)
    name: string = ''

    @property(cc.Node)
    prefab: cc.Node = null

    @property(cc.Float)
    duration: number = 0

    @property(cc.Float)
    scale: number = 1

    node: cc.Node = null
}

@ccclass
@menu('custom/AnimCtr')
export default class AnimCtr extends cc.Component {

    @property([CustomAnimData])
    animDataList: CustomAnimData[] = []

    @property(cc.Node)
    nodeParent: cc.Node = null

    @property(cc.Node)
    nodeParent1: cc.Node = null


    protected m_animDataMap = {}

    onLoad(){
        for (let index = 0; index < this.animDataList.length; index++) {
            const animData = this.animDataList[index];
            this.m_animDataMap[animData.name] = animData
        }
    }

    protected getNode(animData: CustomAnimData): cc.Node{
        if(!animData.node){
            animData.node = cc.instantiate(animData.prefab)
            animData.node.parent = this.nodeParent
            animData.node.position = cc.Vec2.ZERO
            animData.node.scale = animData.scale || 1
        }
        return animData.node
    }

    playAnim(name: string, onFinish?: Function, delay?: number, autoHide?: boolean){
        let self = this
        let animData = this.m_animDataMap[name] as CustomAnimData
        if(animData){
            if(!animData.prefab){
                cc.error(`animData.prefab is null, which name is ${name}`)
                return
            }
            let node = self.getNode(animData)
            node.active = false
            let doAnim = function(){
                node.active = true
                if(animData.duration){
                    self.scheduleOnce(function(){
                        autoHide && (node.active = false)
                        onFinish && onFinish()
                    }, animData.duration)
                }else{
                    node.once(cc.Animation.EventType.STOP, function(){
                        autoHide && (node.active = false)
                        onFinish && onFinish()
                    }, self)
                    node.once(dragonBones.EventObject.COMPLETE, function(){
                        autoHide && (node.active = false)
                        onFinish && onFinish()
                    }, self)
                }                
            }
            if(delay && delay > 0){
                self.scheduleOnce(function(){
                    doAnim()
                }, delay)
            }else{
                doAnim()
            }
        }else{
            cc.error(`no animData which name is ${name}`)
        }
    }    
}